export default __webpack_public_path__ + "static/media/023-sprinkler.e2364ef3.png";